'use strict';

angular.module('far.core')
    .directive('clickover', function ($document, $timeout) {
        return {
            restrict: 'A',
            scope: {
                clickover: '='
            },
            link: function (scope, element) {
                $document.on('click', function (event) {
                    if (event.target != element[0] && !element.has(event.target)) {
                        if (typeof(scope.clickover) == 'function') {
                            $timeout(function () {
                                scope.clickover(event);
                            });
                        }
                    }
                });
            }
        };
    });
